<template>
    <PopupShell
        :image="require(`@/assets/img/icon_check_black.svg`)"
        title="Your listing is updated!"
    > 
        <router-link to="active-listings" class="no-underline">
            <TooliabaButton class="ph3">Okay, thanks!</TooliabaButton>
        </router-link>

    </PopupShell>    
</template>

<script>
import PopupShell from '@/components/editListing/popups/PopupShell.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

export default {
    components: {
        PopupShell,
        TooliabaButton
    }
};
</script>
